<template>
  <div class="main">
    <div class="header">
      <!-- <object data="@/assets/img/logo.svg" type="image/svg+xml" width="300" height="300"  ></object> -->
      <img src="@/assets/imgs/logo-qinlian.png" alt="" class="logo" />
      <ul class="menu">
        <li class="m-item" :class="{ active: $route.path == item.path }" v-for="(item, key) in list" :key="key" @click="goView(item)">{{ item.title }}</li>
        <!-- <li class="m-item last-item">
          微信公众号
          <img src="../assets/imgs/logoQd.png" alt="" class="QRcode" />
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyHeader',
  data() {
    return {
      list: [
        {
          title: '首页',
          path: '/main'
        },
        // {
        //   title: '臻品服务',
        //   path: '/service'
        // },
        // {
        //   title: '区块链浏览器',
        //   path: ''
        // },
        // {
        //   title: '账户注册',
        //   path: '/register'
        // },
        {
          title: '联系我们',
          path: '/contactUs'
        },
        {
          title: '后台登录',
          path: '/login'
        }

      ]
    }
  },
  methods: {
    goView(item) {
      if (item.title == "区块链浏览器") {
        window.open('https://devplatform.cetcxl.com/#/blockBrowser')
        return;
      }
      this.$router.push({ path: item.path })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.main {
  width: 100%;
  height: 72px;
  // border-bottom: 1px solid #0083D5;
  .header {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      width: 177px;
      height: 43px;
    }
    .menu {
      display: flex;
      height: 100%;
      .m-item {
        height: 100%;
        line-height: 69px;
        cursor: pointer;
        margin-right: 40px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
        box-sizing: border-box;
        &.active {
          font-weight: bold;
          border-bottom: 3px solid #fff;
        }
      }
      .last-item {
        position: relative;
        &:hover {
          .QRcode {
            display: block;
          }
        }
        .QRcode {
          width: 180px;
          height: 196px;
          position: absolute;
          left: -55px;
          bottom: -180px;
          z-index: 997;
          display: none;
        }
      }
    }
  }
}
</style>
